// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toasted-container{border-radius:50%!important}.toasted .action{text-transform:none!important}.toasted .svg-inline--fa{margin-right:.5em}@media only screen and (min-width:601px){.toasted-container .toasted{border-radius:var(--input-border-radius)!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
